'use client';

import React, { useEffect, useState } from 'react';
import CardForm from '../../../../components/form/CardForm';
import { Actions } from '../../../../../client/Actions';
import { useParams } from 'react-router-dom';
import OtherFormConfig from './OtherFormConfig';
import { useFetchObject } from '../../../../components/hook/useFetchObject';

const Other = () => {
  let { id } = useParams();

  const {
    data: house,
    ready: houseReady,
    loadData: loadHouse,
  } = useFetchObject('house/' + id, []);

  if (!houseReady) {
    return <></>;
  }

  return (
    <>
      <CardForm
        title={'Inne'}
        fields={OtherFormConfig}
        shadow={false}
        width={12}
        initialData={house}
        customSave={(data, postSave) => {
          const housePayload = { ...house };
          delete housePayload.lastBookingSync;
          delete housePayload.reservationCalendarExportUrl;

          housePayload.rules = data?.rules;
          housePayload.checkinInstruction = data?.checkinInstruction;
          housePayload.googleMapsUrl = data?.googleMapsUrl;
          housePayload.googleMapsMailUrl = data?.googleMapsMailUrl;
          housePayload.bookingCalendarUrl = data?.bookingCalendarUrl;

          Actions.put(
            'house/' + id,

            housePayload,

            loadHouse,
          );
        }}
      />
    </>
  );
};

export default Other;
